export default __webpack_public_path__ + "static/media/CopyAll.2d28c92a.svg";